export const extractCode = () => {
    // extract the redirect url and replace ?redirect= to null to get the code query parameter
    const redirectingUrl = window.location.href;
    if (redirectingUrl) {
        // Decode the URL-encoded string
        const decodedString = decodeURIComponent(redirectingUrl);

        // Create a URL object
        const url = new URL(decodedString);

        // Get the value of the 'code' parameter
        const codeParam = url.searchParams.get("code");

        return codeParam || "";
    } else {
        return "";
    }
};
